import { IsNumberString } from "class-validator";

export class GiftCardCheckRequestDto {
    cardNumber: string;
    
    email: string;
  }
  